import { useEffect, useState } from 'react'

const useDebounce = ( value, delay, initialValue ) => {
  const [ debouncedValue, setDebouncedValue ] = useState( initialValue )

  useEffect( () => {
    const handler = setTimeout( () => {
      setDebouncedValue( value )
    }, delay )

    return () => clearTimeout( handler )
  }, [ value, delay ] )

  return debouncedValue
}

export default useDebounce
